import type { SVGProps } from 'react';

export function CreditCardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width={20} height={14} x={2} y={5} rx={2} />
      <line x1={2} x2={22} y1={10} y2={10} />
    </svg>
  );
}
